import React from 'react'
import { ProfilType } from '../Profil.type'

interface FormDataProps {
  formData: {
    date: Date
    heureVisite: string
    noDateYet: boolean
    proprietaire: string
    adresseBien: string
    ville: string
    codePostal: string
    prix: { email: string; prix: number }[]
    informationsComplementaires: string
    typeBien: string
    selectedProfiles: ProfilType[]
  }
  setFormData: React.Dispatch<
    React.SetStateAction<{
      date: Date
      heureVisite: string
      noDateYet: boolean
      proprietaire: string
      adresseBien: string
      ville: string
      prix: { email: string; prix: number }[]
      informationsComplementaires: string
      codePostal: string
      typeBien: string
      selectedProfiles: ProfilType[]
    }>
  >
  formDataValid: any
  setFormDataValid: React.Dispatch<React.SetStateAction<any>>
}

export default function Part1({
  formData,
  setFormData,
  formDataValid,
  setFormDataValid,
}: FormDataProps) {
  const updatedFormDataValid = formDataValid

  const today = new Date().toISOString().split('T')[0]
  const handleNoDateYetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    setFormData({ ...formData, noDateYet: checked })

    if (checked) {
      // On considère l'étape valide pour passer directement aux profils
      setFormDataValid({ ...updatedFormDataValid, date: true, heureVisite: true })
    } else {
      // Retour au flow normal : on redemande date/heure
      setFormDataValid({ ...updatedFormDataValid, date: false, heureVisite: false })
    }
  }
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateTexte = e.target.value
    const date = new Date(dateTexte)
    const isDateValid = true
    updatedFormDataValid.date = isDateValid
    setFormDataValid(updatedFormDataValid)
    setFormData({ ...formData, date })
  }

  const handleHeureVisiteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const heureVisite = e.target.value
    updatedFormDataValid.heureVisite = heureVisite
    setFormDataValid(updatedFormDataValid)
    setFormData({ ...formData, heureVisite })
  }

  return (
    <div className='space-y-6'>
      <div>
        <h2 className='text-lg sm:text-xl font-extrabold tracking-tight text-gray-900'>
          Planifier votre visite
        </h2>
        <p className='mt-2 text-sm text-gray-700 leading-6'>
          Indiquez une date et une heure, ou choisissez l&apos;option si vous n&apos;avez pas encore
          de créneau.
        </p>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-end'>
        <label className='flex items-start gap-3 rounded-2xl border border-black/10 bg-white/70 px-4 py-4'>
          <input
            type='checkbox'
            checked={formData.noDateYet}
            onChange={handleNoDateYetChange}
            className='mt-1 h-4 w-4 accent-[#f75000]'
          />
          <div>
            <div className='text-sm font-extrabold text-gray-900'>
              Je n&apos;ai pas encore de date
            </div>
            <div className='mt-1 text-sm text-gray-700 leading-6'>
              Vous pourrez sélectionner un visiteur sans fixer la date immédiatement.
            </div>
          </div>
        </label>

        <div className='rounded-2xl border border-black/10 bg-white/70 px-4 py-4'>
          <label className='block text-sm font-semibold text-gray-700'>Date de la visite</label>
          <input
            type='date'
            min={today}
            placeholder='MM/DD/YYYY'
            onChange={handleDateChange}
            disabled={formData.noDateYet}
            className='mt-2 w-full rounded-xl border border-black/10 bg-white/80 px-4 py-3 text-sm text-gray-900 shadow-sm disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-[#f75000]/30'
          />
        </div>

        <div className='rounded-2xl border border-black/10 bg-white/70 px-4 py-4'>
          <label className='block text-sm font-semibold text-gray-700'>Heure de visite</label>
          <input
            type='time'
            value={formData.heureVisite}
            placeholder='JJ/MM/AAAA'
            onChange={handleHeureVisiteChange}
            disabled={formData.noDateYet}
            className='mt-2 w-full rounded-xl border border-black/10 bg-white/80 px-4 py-3 text-sm text-gray-900 shadow-sm disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-[#f75000]/30'
          />
        </div>
      </div>
    </div>
  )
}
